import React, { useState } from "react";
import CustomInput from "../../components/CustomInput";
import Notification from "../../components/ui-elements/Notification";
import {
  createPost,
  deletePost,
  deletePostImage,
  updatePost,
  uploadPostImage,
} from "../../services/ecommerceElements";
import { IS_LOCAL_ENV } from "../../App";
import ModalStructure from "../../components/ModalStructure";

const PostCard = ({ prevData, uploadToParent, removeFromParent }) => {
  const [imgFile, setImgFile] = useState(null);
  const [fetching, setFetching] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    title: prevData?.title || "",
    description: prevData?.description || "", //test, richtext or textarea
    image: prevData?.image || null, //object
    preTitle: prevData?.preTitle || "",
    url: prevData?.url || null, //white por default
  });

  const validateForm = () => {
    let result =
      formData?.title?.trim() != "" && formData?.description?.trim() != "";

    if (!prevData) result = result && imgFile != null;
    return result;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    if (!validateForm()) {
      Notification({
        title: "Operación inválida",
        text: "Datos incompletos",
        type: "Error",
      });
      return;
    }
    setFetching(true);
    const uploadData = async () => {
      try {
        let newImgObj = null;
        if (imgFile != null) {
          //eliminar imagen anterior en caso exista
          if (prevData) await deletePostImage(formData.image.id);
          //cargar nueva imagen
          newImgObj = await uploadPostImage({
            alt: imgFile.name,
            file: imgFile,
          });
          //newImgId = resim.id;
        }
        if (newImgObj != null) formData.image = newImgObj.doc;

        let formToSend = {
          title: formData.title,
          description: formData.description,
          image: formData.image.id,
          preTitle: formData.preTitle,
          url: formData.url,
        };

        //Preparar los datos a enviar

        IS_LOCAL_ENV && console.log("data a enviar", formToSend);
        let response = {};

        if (prevData) {
          response = await updatePost(prevData.id, formToSend);
          IS_LOCAL_ENV && console.log("response", response.doc);
        } else {
          response = await createPost(formToSend);
          IS_LOCAL_ENV && console.log("response", response.doc);
        }

        Notification({
          title: "Operación completada",
          text: `Se ${prevData ? "actualizó" : "creó"} el post con éxito`,
          type: "Success",
        });

        setFetching(false);
        !prevData && uploadToParent(response.doc);
      } catch (err) {
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        setFetching(false);
      }
    };
    uploadData();
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    setFetching(true);
    const deleteFetch = async () => {
      try {
        //eliminar imagen anterior
        if (formData?.image) await deletePostImage(formData.image.id);

        const { data } = await deletePost(id);
        Notification({
          title: "Operación completada",
          text: `Se eliminó el banner con éxito`,
          type: "Success",
        });
        setFetching(false);
        removeFromParent(prevData.id);
      } catch (err) {
        setFetching(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };

    deleteFetch();
    setShowModal(false);
  };

  const handleContentChange = (data) => {
    console.log("data", data);
    setFormData((prev) => ({ ...prev, description: data }));
  };

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0]; // Obtén el primer archivo seleccionado
    if (selectedFile) {
      // Verifica si el archivo es un PDF
      if (selectedFile.type.startsWith("image/") && type == "image") {
        setImgFile(selectedFile);
      } else {
        Notification({
          title: "Operación inválida",
          text: "Por favor selecciona una imagen.",
          type: "Error",
        });
      }
    }
  };

  return (
    <form className="flex h-fit min-w-[400px] max-w-[400px] flex-col p-4 border-[1px] rounded-xl border-accent-green gap-4 hover:shadow-md hover:cursor-pointer bg-white">
      {/**image */}

      {!prevData && (
        <h2 className="font-semibold text-2xl text-start px-2 pt-2">
          Nuevo post
        </h2>
      )}

      <div className="flex flex-col w-full gap-4 pb-2">
        {formData?.image?.url && (
          <div className="flex flex-col h-[200px] w-full">
            <img
              src={`${process.env.REACT_APP_SERVER}${formData?.image?.url}`}
              alt="Cropped example"
              className="w-full h-full object-cover object-center rounded-[5px]"
            />
          </div>
        )}

        <div className="px-2 w-full">
          <span className="font-poppins font-bold">
            {prevData ? "Reemplazar imagen" : "Cargar imagen *"}{" "}
          </span>
          <input
            className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-full  text-sm"
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "image")}
          />
        </div>
      </div>

      {/**pre title */}
      <CustomInput
        value={formData.preTitle}
        onChange={(e) => setFormData({ ...formData, preTitle: e.target.value })}
        title="Pre título"
        inputType="text"
        placeholder="Ej: Nuevo Banner"
      />

      {/**title */}
      <CustomInput
        value={formData.title}
        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
        title="Título"
        inputType="text"
        required={true}
        placeholder={"Ej: Producto de estreno"}
      />

      {/**description */}
      <CustomInput
        value={formData.description}
        onChange={(e) =>
          setFormData({ ...formData, description: e.target.value })
        }
        title="Descripción"
        inputType="textarea"
        required={true}
        placeholder={"Ej: Lorem ipsum"}
      />

      {/*url */}
      <CustomInput
        value={formData.url}
        onChange={(e) => setFormData({ ...formData, url: e.target.value })}
        title="Url"
        inputType="text"
        placeholder={"Ej: https://nectaryraiz.com/shop/PLANT-ORQPH-CMO-EFL"}
      />

      <div className="flex flex-row gap-x-2 w-full px-2 h-fit">
        <button
          disabled={fetching}
          type="submit"
          onClick={handleSubmit}
          className={` ${
            fetching
              ? "bg-light-gray cursor-not-allowed"
              : "bg-dark-green hover:bg-accent-green"
          }  w-full  text-base rounded-full py-2 px-6 text-white  transition-all duration-100 font-bold font-poppins`}
        >
          {prevData ? "Actualizar" : "Crear"}
        </button>
        {prevData && (
          <button
            onClick={(e) => {
              e.preventDefault();
              setShowModal(true);
            }}
            className={`${
              fetching
                ? "bg-light-gray cursor-not-allowed"
                : "bg-red-600 hover:hover:bg-red-500"
            } w-full  text-base rounded-full py-2 px-6 text-white transition-all duration-100 font-bold font-poppins`}
          >
            Eliminar
          </button>
        )}
      </div>
      {showModal && (
        <ModalStructure
          handleCloseModal={() => setShowModal(false)}
          customMaxW={"max-w-[400px]"}
        >
          <div className="flex flex-col items-center justify-center gap-y-2 p-4">
            <h3 className="font-bold text-dark-green text-lg text-center">
              ¿Estás seguro de eliminar este banner?
            </h3>
            <button
              disabled={fetching}
              className={`${
                fetching
                  ? "bg-light-gray cursor-not-allowed"
                  : "hover:bg-red-300 bg-red-500"
              } text-white rounded-full py-2 px-4 text-base font-poppins`}
              onClick={(e) => (fetching ? null : handleDelete(e, prevData.id))}
            >
              Eliminar
            </button>
          </div>
        </ModalStructure>
      )}
    </form>
  );
};

export default PostCard;
